import InfiniteScroll from 'react-infinite-scroll-component';
import Loading from '../../Common/components/Loading';
import './Gallery.css';
import logo from './white_logo.png';
import GalleryPreviewImage from './GalleryPreviewImage';
import { useEffect, useState } from 'react';
import FindMyPhotosModal from './FindMyPhotosModal';
import useGalleryViewLogger from '../../Stats/components/hooks/useGalleryViewLogger';
import { Button } from '@/src/shadComponents/ui/button';
import MetaPixel from '@/src/Common/components/MetaPixel';
import GalleryCTA from './GalleryCTA';

interface GalleryViewProps {
    gallery: GalleryObject | null;
    isLoading?: boolean;
    photos: MediaInstance[];
    delayed?: boolean;
    expandedIndex: number;
    setExpandedIndex: (expandedIndex: number) => void;
    swipeHandlers: any;
    loadedPhotos: MediaInstance[];
    getNewPage: (size: number) => void;
    message?: string | React.ReactNode;
}

export default function GalleryView({
    gallery,
    isLoading = false,
    photos,
    delayed = true,
    expandedIndex,
    setExpandedIndex,
    swipeHandlers,
    loadedPhotos,
    getNewPage,
    message = '',
}: GalleryViewProps) {
    const [showFindMyPhotosModal, setShowFindMyPhotosModal] =
        useState<boolean>(false);

    const galleryId = gallery?.id || 0;
    const { logGalleryView } = useGalleryViewLogger();

    useEffect(() => {
        if (galleryId) {
            logGalleryView(galleryId);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [galleryId]);

    let hasMore = photos.length > loadedPhotos.length;

    return (
        <>
            <Loading isLoading={isLoading} />
            {!isLoading && (
                <div
                    className={`Gallery-header ${
                        expandedIndex !== -1 ? 'hidden invisible' : ''
                    }`}
                >
                    <div className="Gallery-header-title">
                        <img
                            src={gallery?.logo || logo}
                            alt="Smilebooth Logo"
                        />
                    </div>
                    <div className="Gallery-name">{gallery?.name}</div>
                </div>
            )}
            <div className="Gallery-content" id="galleryContainer">
                {gallery?.metaPixelId && (
                    <MetaPixel pixelId={gallery?.metaPixelId} />
                )}

                <div className="Gallery-grid-container">
                    <div
                        {...swipeHandlers}
                        className={`Gallery-grid ${delayed ? '' : 'hide'}`}
                    >
                        <InfiniteScroll
                            dataLength={loadedPhotos.length}
                            next={() => getNewPage(10)}
                            style={{
                                display: 'grid',
                            }}
                            hasMore={hasMore}
                            loader={<Loading isLoading={true} />}
                            scrollThreshold="200px"
                            scrollableTarget="galleryContainer"
                        >
                            {loadedPhotos.map((photo, index) => {
                                return (
                                    <GalleryPreviewImage
                                        media={photo}
                                        key={photo.shareIdentifier}
                                        isExpanded={expandedIndex === index}
                                        setExpandedIndex={setExpandedIndex}
                                        index={index}
                                    />
                                );
                            })}
                        </InfiniteScroll>
                    </div>
                    {hasMore ? (
                        <div className="flex justify-center">
                            <Button
                                className="Primary-button h-12 w-48"
                                onClick={() => getNewPage(10)}
                            >
                                Load More
                            </Button>
                        </div>
                    ) : null}
                </div>

                {message ? (
                    <div className="Gallery-message">
                        <p>{message}</p>
                    </div>
                ) : null}
            </div>
            {expandedIndex === -1 ? <GalleryCTA gallery={gallery} /> : null}
            {/*<div
                className={`Find-your-own-photos-banner clickable ${
                    expandedIndex > -1 ? 'hidden' : ''
                }`}
                onClick={() => setShowFindMyPhotosModal(true)}
            >
                <h3 className="looking-for-prompt">
                    Looking for your own photos?
                </h3>
            </div>
            */}
            {showFindMyPhotosModal ? (
                <FindMyPhotosModal
                    setShowModal={(show) => setShowFindMyPhotosModal(show)}
                />
            ) : null}
        </>
    );
}
